import { Batch } from "../../modules/masters/batch/models/batch.model";

export interface BatchState {
  batches: Batch[];
  selectedBatch: Batch | null;
  loading: boolean;
  error: string | null;
  duplicateExists: boolean | null;
}

export const initialBatchState: BatchState = {
  batches: [],
  selectedBatch: null,
  duplicateExists: null,
  loading: false,
  error: null,
};
